import { Accordion } from '@curology/ui-components-web/react/Accordion';
import { AccordionContent } from '@curology/ui-components-web/react/Accordion/AccordionContent';
import { AccordionSummary } from '@curology/ui-components-web/react/Accordion/AccordionSummary';
import { Button } from '@curology/ui-components-web/react/Button';
import { Highlight } from '@curology/ui-components-web/react/Highlight';
import { Image } from '@curology/ui-components-web/react/Image';
import { Modal } from '@curology/ui-components-web/react/Modal';
import { ModalContent } from '@curology/ui-components-web/react/Modal/ModalContent';
import { ModalHeader } from '@curology/ui-components-web/react/Modal/ModalHeader';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

const DeepCleanseRxModal = ({
  setShowModal,
  showModal,
}: {
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  showModal: boolean;
}) => {
  return (
    <Modal
      onClose={() => setShowModal(false)}
      open={showModal}
      title={
        <ModalHeader>
          Deep Cleanse<sup>Rx</sup>
        </ModalHeader>
      }
      type="light"
      width={550}
    >
      <ModalContent className="cur-bg-[#ffffff] cur-p-0">
        <Image
          alt="Deep Cleanse Rx modal header image"
          aspectRatio="4:3"
          src="https://images.ctfassets.net/mdcr7mahi0vp/73BGhSlILoekNwdasKRxfJ/95cacfd445e763278056066435e51ab3/deep_cleanse_modal.png"
        />
        <div className="cur-p-6">
          <Typography size="h2">
            Deep Cleanse<sup>Rx</sup>
          </Typography>
          <Typography className="cur-mb-4">
            Personalized Acne Cleanser
          </Typography>
          <Highlight className="cur-my-4" state="success">
            Helps <span className="cur-font-bold">clear skin</span> and{' '}
            <span className="cur-font-bold">prevent future breakouts</span>
          </Highlight>
          <Typography className="cur-my-4" size="h3">
            Why it’s special
          </Typography>
          <Typography className="cur-my-4">
            Your custom cleanser is is dermatologist-designed to work harder
            than your standard, off-the-shelf face wash. This
            gentle-yet-powerful cleanser goes deep into clogged pores to clear
            away dead skin cells and excess oil—helping clear skin and prevent
            future breakouts.
          </Typography>
          <Typography className="cur-my-4">
            Unlike other cleansers that rely on a single active ingredient
            alone, your custom cleanser is is formulated using personalized
            combinations of clinically-proven prescription ingredients—each one
            selected by your dermatology provider for your individual skin
            goals. All you have to do is wash your face to work toward clearer,
            cleaner skin.
          </Typography>
          <Typography className="cur-my-4">
            Your provider will review your information and photos, and then
            prescribe a personalized combination from the following active
            ingredients for your skin’s unique needs.
          </Typography>
          <Typography className="cur-my-4" size="h3">
            How to use it
          </Typography>
          <Typography className="cur-my-4">
            Gently massage a nickel-sized amount (or half pump) of cleanser onto
            damp skin once or twice a day. Leave on for up to 30 seconds prior
            to rinsing off, if tolerated.
          </Typography>
          <Typography className="cur-my-4" size="h3">
            Featured ingredients
          </Typography>
          <Accordion className="cur-my-4">
            <AccordionSummary>Sulfacetamide sodium</AccordionSummary>
            <AccordionContent>
              Helps to fight acne-contributing bacteria on the skin
            </AccordionContent>
          </Accordion>
          <Accordion className="cur-my-4">
            <AccordionSummary>Zinc pyrithione</AccordionSummary>
            <AccordionContent>
              Soothes inflammation and helps keep bacteria and fungi in check
            </AccordionContent>
          </Accordion>
          <Accordion className="cur-my-4">
            <AccordionSummary>Salicylic acid</AccordionSummary>
            <AccordionContent>
              Goes deep into pores to clear away dead skin cells and excess oil
            </AccordionContent>
          </Accordion>
          <Typography className="cur-my-4" size="h3">
            Full ingredients list
          </Typography>
          <Typography className="cur-my-4">
            Water, Sodium Cocoyl Isethionate, Cocamidopropyl Hydroxysultaine,
            Acrylates Copolymer, Propanediol, Xylitylglucoside, Coconut Alcohol,
            Coco-Glucoside, Anhydroxylitol, Stearic Acid, 1,2-Hexanediol,
            Panthenol, Sodium Hydroxide, Xylitol, PEG-150 Pentaerythrityl
            Tetrastearate, Stearyl Alcohol, Glycerin, Citric Acid, Sodium
            Chloride, Sodium Isethionate, Caprylhydroxamic Acid, Xanthan Gum,
            Glucose, Potassium Sorbate, Avena Sativa (Oat) Kernel Extract
          </Typography>
          <div className="cur-mt-4">
            <Button
              buttonType="secondary"
              className="cur-w-full"
              onClick={() => setShowModal(false)}
            >
              Done
            </Button>
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default DeepCleanseRxModal;
